import { render } from "./formArea.vue?vue&type=template&id=f2baa04c&ts=true"
import script from "./formArea.vue?vue&type=script&lang=ts"
export * from "./formArea.vue?vue&type=script&lang=ts"

import "./formArea.vue?vue&type=style&index=0&id=f2baa04c&lang=less"

import exportComponent from "E:\\qihe\\ly-visitor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__